export default __webpack_public_path__ + "static/media/fr-asia-3.c526131b.jpg";